import QuitImg from '@/assets/imgs/quit.svg';

import Auxiliary from '../Auxiliary';

interface QuitProps {
  handleReturn: () => void;
  handleClose: () => void;
}

export default function Quit({ handleReturn, handleClose }: QuitProps) {
  return (
    <Auxiliary
      screen="quit"
      title="¿Seguro que quieres abandonar el proceso?"
      imgSrc={QuitImg}
      mainButton="Regresar"
      secondaryButton="Abandonar"
      handleMainButton={() => handleReturn()}
      handleSecondaryButton={() => handleClose()}
    />
  );
}
